import { apiUrl } from '../runtime'

// Browser replacements for the notification server actions, hitting core's backend directly
// with the shared session cookie. Shapes mirror @/app/actions/notifications.
export interface AppNotification {
  id: number
  kind: string
  title: string
  body: string
  link: string | null
  is_read: boolean
  created_at: string
}

export async function fetchNotifications(): Promise<AppNotification[]> {
  try {
    const res = await fetch(apiUrl('/api/notifications'), { credentials: 'include', cache: 'no-store' })
    if (!res.ok) return []
    return await res.json()
  } catch {
    return []
  }
}

export async function markAllRead(): Promise<void> {
  try {
    await fetch(apiUrl('/api/notifications/mark-all-read'), { method: 'POST', credentials: 'include' })
  } catch {
    /* ignore */
  }
}

export async function markOneRead(id: number): Promise<void> {
  try {
    await fetch(apiUrl(`/api/notifications/${id}/mark-read`), { method: 'POST', credentials: 'include' })
  } catch {
    /* ignore */
  }
}
